import React from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc'; // https://github.com/clauderic/react-sortable-hoc

import NewScopeCategory from "./newScopeCategory";
import NewScopeWizardItem from "./newScopeWizardItem";

const SortableItem = SortableElement(({ qtCategory, qtCategoryIndex }) => {
  return <NewScopeCategory qtCategoryIndex={qtCategoryIndex} qtCategory={qtCategory} />
});

const SortableList = SortableContainer(({ qtCategories, wizardList, isWizardMode }) => {

  if (isWizardMode) {
    return (
      <ul className={"assign-sidebar-list assign-sidebar-list--qt"}>
        {wizardList.map((wizardItem, wizardItemIndex) => {
          return <NewScopeWizardItem key={`item-wizard-${wizardItem.order}-${wizardItemIndex}`}
                                     qtCategoryIndex={wizardItemIndex}
                                     wizardItem={wizardItem} />
        })}
      </ul>
    )
  }

  return (
    <ul className={"assign-sidebar-list assign-sidebar-list--qt"}>
      {qtCategories.map((qtCategory, qtCategoryIndex) => {

        if (qtCategory.order === 0) return <NewScopeCategory key={`item-${qtCategory.order}`}
                                                             qtCategoryIndex={qtCategoryIndex}
                                                             qtCategory={qtCategory} />;

        return <SortableItem key={`item-${qtCategory.order}-${qtCategoryIndex}`}
                             index={qtCategoryIndex}
                             qtCategoryIndex={qtCategoryIndex}
                             qtCategory={qtCategory} />
      })}
    </ul>
  );
});

export default ({ qtCategories, onSortEnd, shouldCancelStart, wizardList, isWizardMode }) => {
  return <SortableList qtCategories={qtCategories}
                       wizardList={wizardList}
                       isWizardMode={isWizardMode}
                       helperClass='sortableHelper'
                       axis={"y"}
                       pressDelay={100}
                       shouldCancelStart={shouldCancelStart}
                       onSortEnd={onSortEnd} />
}
